import React from 'react';
import css from './styles.module.scss';
import { Box, Collapse, List, ListItem, ListItemText, Paper, Typography } from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import GetAppIcon from '@material-ui/icons/GetApp';
import EditIcon from '@material-ui/icons/Edit';
import Slider from 'react-slick';
import DeleteIcon from '@material-ui/icons/Delete';
// import documentIcon from '~/img/document-icon.png';
// import documentIcon2 from '~/img/document-icon-2.png';
import documentIcon from '~/img/document-icon-3.png';
import useToggle from '~/utils/hooks/useToggle';

export type AssetType = {
    assetName: string;
    assetVersion: string;
    assetPath: string;
};

type Props = {
    title: string;
    assets?: AssetType[];
    deleteAsset(id: number): void;
    editAsset(asset: any): void;
    expanded?: boolean;
};

export const CollapsibleSlider: React.FC<Props> = ({ title, assets, deleteAsset, editAsset, expanded = false }) => {
    const [isOpen, toggle] = useToggle(expanded);

    const downloadAsset = (assetPath: string): void => {
        const fileUrl = assetPath[0] === '/' ? `${process.env.REACT_APP_ASSET}${assetPath}` : assetPath;
        window.open(fileUrl, '_blank');
    };

    const getDocumentPreview = (assetPath?: string, category?: string): JSX.Element => {
        // let fileUrl = category === 'Contract' ? documentIcon : documentIcon2;
        let fileUrl = documentIcon;
        if (assetPath) {
            const tmpUrl = assetPath[0] === '/' ? `${process.env.REACT_APP_ASSET}${assetPath}` : assetPath;
            if (['jpg', 'jpeg', 'png', 'gif', 'svg'].includes(tmpUrl.slice(-3).toLowerCase())) {
                fileUrl = tmpUrl;
            }
        }

        return (
            <div className={css.tileImage} style={{backgroundImage: `url(${fileUrl})`}} />
        );
    };

    const NextArrow = (props: any) => {
        return <div className={css.sliderArrowNext} onClick={props.onClick} />;
    };

    const PrevArrow = (props: any) => {
        return <div className={css.sliderArrowPrev} onClick={props.onClick} />;
    };

    let sliderSettings = {
        infinite: true,
        speed: 300,
        centerMode: false,
        variableWidth: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        adaptiveHeight: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
    };

    return (
        <>
            {assets && assets.length > 0 && (
                <Box className={css.module}>
                    <ListItem onClick={toggle} button className={css.tab}>
                        <ListItemText primary={title} color="white" />
                        {isOpen ? <ExpandLess /> : <ExpandMore />}
                    </ListItem>
                    <Collapse in={isOpen} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <Box className={css.assets}>
                                <Slider {...sliderSettings}>
                                    {assets.map((a: any) => (
                                        <Box className={css.assetTileWrapper} key={a.id}>
                                            <Paper className={css.assetTile} elevation={0}>
                                                <Box className={css.tileActions}>
                                                    {a.assetPath && (<GetAppIcon className={css.actionBtn} onClick={() => downloadAsset(a.assetPath)} />)}
                                                    <EditIcon onClick={() => editAsset(a)} className={css.actionBtn} />
                                                    <DeleteIcon onClick={() => deleteAsset(a.id)} className={css.actionBtn} />
                                                </Box>
                                                {getDocumentPreview(a.assetPath, a.assetTags)}
                                            </Paper>
                                            {a.assetName && (
                                                <Typography className={css.tileDescription}>
                                                    {a.assetName}
                                                    {a.assetVersion && <Typography component="span" variant="caption"> {a.assetVersion.trim()}</Typography>}
                                                </Typography>
                                            )}
                                        </Box>
                                    ))}
                                </Slider>
                            </Box>
                        </List>
                    </Collapse>
                </Box>
            )}
        </>
    );
};

export default CollapsibleSlider;
